<template>
  <div>
   <!-- toasts message -->
   <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
   <!-- /toasts message -->
   <!-- Form -->  
   <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text>         
      <!-- {{formSchema}}  -->
        <v-container grid-list-md>
          <v-layout wrap> 
            <v-flex xs12 sm6 md4>                 
            <v-autocomplete            
            label="Finencial Year"
            item-text="financialYears"
            v-model="dateValue.financial_year"            
            :items="BudgetingYearList" 
            @input="selectFinancialYear(dateValue.financial_year)"
            clearable       
            ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md4>   
              <DatePicker
              :key="dateValue.fundRelease_id"
              :inputData="{index:1,fieldName:'received_date', fieldValue:dateValue.received_date, label:'Received Date',required:'1'}"
              @setValue="setDateValue"
              ></DatePicker>
            </v-flex>
            <v-flex xs12 sm4 md4>
                  <label for="">Document-01</label>
                  <input type="file" @change="getImage" id="doc01" class="form-control"/>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
                  <v-icon>save</v-icon>
                  {{addUpdateBtn}}
                </v-btn>

                <v-btn color="error" @click="previous">
                  <v-icon>arrow_back_ios</v-icon>Back
                </v-btn>          
              </v-card-actions>
            </v-flex>   

            <!-- _______________1st Table_______________ -->
            <v-flex xs12 sm12 md12>
              <div class="table-height">
                <table class="BIPTable table-sticky" width="100%">
                  
                    <thead class="textCenter textBold">
                    <tr>
                      <th rowspan="2">Economic Code</th>
                      <th rowspan="2">Economic Name</th>
                      <th colspan="3">
                        <table width="100%" class="BIPTable">
                          <tr class="textCenter">
                            <th colspan="3">Budget Amount</th> 
                          </tr>
                          <tr>
                            <th>GoB</th>
                            <th>IDA</th>
                            <th>Total</th>
                          </tr>
                        </table>
                      </th>
                      <th colspan="3">
                        <table width="100%" class="BIPTable">
                          <tr class="textCenter">
                            <th colspan="3">Received Amount</th> 
                          </tr>
                          <tr>
                            <th>GoB</th>
                            <th>IDA</th>
                            <th>Total</th>
                          </tr>
                        </table>
                      </th>
                     
                      <th rowspan="2">GoB</th>
                      <th rowspan="2">IDA</th>
                      <th rowspan="2">Total</th>
                    </tr>
                    <tr>
                     
                    </tr>

                    </thead>
                  <!-- <tbody> -->
                    <tr v-for="(val,index) in formSchema" :key="index">
                      <td>                          
                        <v-text-field hide-details v-model="formSchema[index].eco_account_code" readonly></v-text-field>  

                         <input type="hidden" v-model="formSchema[index].eco_code_id" readonly/>
                      </td>
                      <td>
                        <v-text-field hide-details v-model="formSchema[index].eco_account_name" readonly></v-text-field>
                      </td>

                      <td>
                        <v-text-field class="textRight" hide-details v-model="formSchema[index].budget_gob_amount" readonly></v-text-field>
                      </td>
                      <td>
                        <v-text-field class="textRight" hide-details v-model="formSchema[index].budget_ida_amount" readonly></v-text-field>
                      </td>
                      <td>
                        <v-text-field class="textRight" hide-details v-model="formSchema[index].budget_total_amount" readonly></v-text-field>
                      </td>
                      <td>
                        <v-text-field hide-details v-model="formSchema[index].received_gob_amount" readonly></v-text-field>
                      </td>
                      <td>
                        <v-text-field hide-details v-model="formSchema[index].received_ida_amount" readonly></v-text-field>
                      </td>
                      <td>
                        <v-text-field hide-details v-model="formSchema[index].received_amount" readonly ></v-text-field>
                      </td>
                      <td>
                        <v-text-field hide-details v-model="formSchema[index].pay_gob_amount"
                        @input="EnterAmount(index, $event)"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field hide-details v-model="formSchema[index].pay_ida_amount"
                        @input="EnterAmount(index, $event)"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field hide-details v-model="formSchema[index].total_pay_amount" readonly></v-text-field>
                      </td>
                    </tr>
                  <!-- </tbody> -->
                </table>
              </div>
              </v-flex>
              <!-- _______________/1st Table_______________ -->

              

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>

          <v-btn color="error" @click="previous">
            <v-icon>arrow_back_ios</v-icon>Back
          </v-btn>          
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema", "dateValue"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    is_activeVal:1,  
    BudgetingYearList: utilities.getBudgetingYearList(),

    storeFormSchema: [
        {
          id: 0,
          eco_code_id: "",
          eco_account_code:"",
          eco_account_name: "", 
                 
          budget_gob_amount:0,    
          budget_ida_amount:0,
          budget_total_amount:0,
                  
          received_amount:0,
          pay_gob_amount:0,
          pay_ida_amount:0,
          total_pay_amount:0,       
        },
      ], 

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },
  }),

  computed: {
    formTitle() {
      return 'Budget Wise Fund Release';     
    },
    addUpdateBtn() {
      return this.dateValue.id > 0 ? "Update" : "Save";
    }
  },

  methods: {
    getImage(e){
       let fileReader = new FileReader();
       fileReader.readAsDataURL(e.target.files[0])
       fileReader.onload = (e) => {
          this.dateValue.document_01 = e.target.result        
       }
       console.log('file got')
    },
    checkFinancialYear()
    {
      var dt = this.dateValue;
      let dates = this.changeFormateYMD(dt.received_date);

      commonService.getAllData("check-financial-year/"+dt.financial_year+"/"+dates).then(res => {
        if(res.total > 0)
        {
          this.SnackbarVal.color = "error";         
          this.SnackbarVal.message = "Same financial year and date already exists";
          this.SnackbarVal.snackbar = true;
          this.dateValue.financial_year = 0;
        }
      })
    },

    setDateValue(data) {
      let index = data.index
      this.dateValue[data.fieldName] = data.value;
      this.checkFinancialYear();
    },

    SumValues(fieldName,totalFiel)
    {
      let A = this.formSchema.quater[0][fieldName];
      let B = this.formSchema.quater[1][fieldName];
      let Total = this.formSchema[totalFiel] = ((parseFloat(A) || 0) + (parseFloat(B)||0)).toFixed(3);
    },
    
    selectFinancialYear:function(financialYear){
     
      if(typeof financialYear !== "undefined")
      {
        this.checkFinancialYear();
        commonService.getAllData("get-financial-year-data/"+financialYear+"/0").then(res => {
          let $this = this;
          if(res.proBudget_detail){
            this.$emit("backFormschema", {'formSchema':res.proBudget_detail});
          }
        });
      }
    },

    EnterAmount(index, e){
      let formSchema = this.formSchema[index];

      formSchema.total_pay_amount = Number(formSchema.pay_gob_amount||0) + Number(formSchema.pay_ida_amount||0)
      let totalBudgetAmounts = Number(formSchema.budget_gob_amount||0) + Number(formSchema.budget_ida_amount||0);
      let receivedAmount = Number(formSchema.received_gob_amount||0) + Number(formSchema.received_ida_amount||0);

      let TotalEnterAmount = Number(formSchema.pay_gob_amount||0) + Number(formSchema.pay_ida_amount||0);

      let availableAmount = (totalBudgetAmounts - receivedAmount);

      let budget_gob_amount = Number(formSchema.budget_gob_amount || 0)
      let budget_ida_amount = Number(formSchema.budget_ida_amount || 0)
      let recv_gob_amount = Number(formSchema.received_gob_amount || 0)
      let recv_ida_amount = Number(formSchema.received_ida_amount || 0)

      // let cost_gob_amount = Number(formSchema.cost_gob_amount || 0)
      // let cost_ida_amount = Number(formSchema.cost_ida_amount || 0)
      // let totalCost = Number((cost_gob_amount + cost_ida_amount) || 0);

      let remain_gob_amt = budget_gob_amount - recv_gob_amount
      let remain_ida_amt = budget_ida_amount - recv_ida_amount

      let EnterGobAmount = Number(formSchema.pay_gob_amount||0);
      let EnterIdaAmount = Number(formSchema.pay_ida_amount||0);
      
      if(availableAmount < TotalEnterAmount || remain_gob_amt < EnterGobAmount || remain_ida_amt < EnterIdaAmount)
      {
        this.valid = false;
        this.SnackbarVal.color = "error"; 
        this.SnackbarVal.message = "The amount exceeds the available balance"
        this.SnackbarVal.snackbar = true;
        // formSchema.pay_ida_amount = 
       
        return 0;
      } else  {
        this.valid = true;
      }

    },

    validateBeforeSubmit(e) {

      var formSchema = this.formSchema;

      console.log(formSchema);

      var dateValue = this.dateValue;
      dateValue.received_date = this.changeFormateYMD(
        dateValue.received_date
        );

      var formData = {"dateValue": dateValue, "formSchema": formSchema}

      if (this.$refs.form.validate()) {     

        let func_name = 'insertFormData';
        if(dateValue.id>0)
        {
          func_name = 'updateFormData';
          formData.id = dateValue.id;
        }

        commonService[func_name](formData, "budget-wise-fund-release").then(res => {
          let actionData = {
            message: res.message,
            data: res.data,
            action: res.action,
            status: res.status
          };

          if (res.status == 1) {
            this.formSchema.id = 0;
            this.formSchema.received_date = ''
          }
          this.close(actionData);
        });
      }
    },
    
    previous:function()
    {
      //this.$refs.form.reset();
      this.$emit("emitForm", {'status':'back'});
    },

    close: function(data) {      
      //this.$refs.form.reset();
      this.$emit("emitForm", data);
    }
  }
};
</script>
<style scoped>

.textRight input{
  text-align: right !important;
}
.v-text-field{
  padding-top: 0px !important;
}
table.BIPTable{
  border-collapse: collapse;
}
.BIPTable th,
.BIPTable tr td{
  border:1px solid #CCC !important;  
  line-height: 20px;
}
.BIPTable tr.textCenter,
.textCenter
{
  text-align: center;
}
.BIPTable tr.textBold,
.textBold{
  font-weight: bold;
}

.table-sticky>thead>tr>th,
.table-sticky>thead>tr>td {
	background: green;
	color: #fff;
	top: 0px;
	position: sticky;
}

.table-height {
	height: 320px;
	display: block;
	overflow: scroll;
	width: 100%;
}

.table-bordered>thead>tr>th,
.table-bordered>tbody>tr>th,
.table-bordered>thead>tr>td,
.table-bordered>tbody>tr>td {
	border: 1px solid #ddd;
}

</style>


// WEBPACK FOOTER //
// src/components/project_info/budgetWiseFundRelease/insertForm.vue